export default function setReducer(state, action) {
	return action.value;
}
